/**
 * Authentication service
 */

import { get } from 'api/axios-client';
import logger from 'core/utils/logger';

export interface LoginRequest {
  companyIdentity: string;
  databaseIdentity: string;
  username: string;
  password: string;
}

export interface User {
  userName: string;
  defaultLocationIdentity: number;
  identity: number;
  isSalesPerson: boolean;
  userNameAndCompany: string;
  company: string;
  isTechnician: boolean;
  companyName: string;
  hasAuditLogAccess: boolean;
  //
}

export interface UserOption {
  value: string;
  label: string;
}

const controllerUrl = 'api/ApplicationUser/';

class UserService {
  async getUserByUserName(userName: string): Promise<User> {
    try {
      logger.info('Fetch user', {
        username: userName,
      });

      // Debug: Log the full URL being called
      const fullUrl = `${controllerUrl}GetAppUserByUserName?searchTerm=${userName}`;
      //console.log('🔐 Login URL:', fullUrl);

      const response = await get<User>(fullUrl);

      if (response.data) {
        // Store the backend service URL for future API calls
        localStorage.setItem('user', JSON.stringify(response.data));

        return response.data;
      } else {
        throw new Error(response.data || 'Login failed');
      }
    } catch (error) {
      logger.error(
        'Login failed',
        {
          username: userName,
        },
        error as Error
      );
      throw error;
    }
  }

  async getAllUsers(): Promise<UserOption[]> {
    try {
      logger.info('Fetching all users');

      const url = `${controllerUrl}GetAllUsers`;
      const response = await get<User[]>(url);

      // Transform users to options format
      const userOptions: UserOption[] = response.data.map(user => ({
        value: user.identity.toString(),
        label: user.userName || `User ${user.identity}`,
      }));

      logger.info('All users fetched', { count: userOptions.length });
      return userOptions;
    } catch (error) {
      logger.error('Failed to fetch all users', {}, error as Error);
      // Return empty array on error to prevent breaking the UI
      return [];
    }
  }
}

export const userService = new UserService();
export default userService;
